import { API_URL } from 'api/constants'

export const GET_SUBSCRIPTION_STATUS = `${API_URL}/v1/feature/get_subscription_status`
export const GET_FEATURE_PRICE_PER_MONTHS = `${API_URL}/v1/feature/get_feature_price_per_months`
export const GET_FEATURE_PRICE = `${API_URL}/v1/billings/feature_price`
export const END_TUTORIAL = `${API_URL}/v1/feature/finish_tutorial`
export const ACTIVATE_TRIAL = `${API_URL}/v1/feature/activate_trial`



// WEBPACK FOOTER //
// ./app/api/feature/constants.js